import { Component, OnInit, Inject, ViewEncapsulation, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MeteringPoint, MeteringPointGroup } from '@model';
import * as fromStore from '@appStore/metering-points';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-metering-group-form',
    templateUrl: './metering-group-form.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MeteringGroupFormComponent implements OnInit, OnDestroy {
  @ViewChild('groupName', { static: true })
  groupNameField: ElementRef;

  meteringPointsToAdd: MeteringPoint[];
  meteringGroups$: Observable<MeteringPointGroup[]>;
  meteringGroupsView: MeteringPointGroup[];

  addingNewGroup: boolean;
  newGroupName: string;
  newCounter = 0;
  hasNoSelection = true;

  private subs = new SubSink();

  constructor(
    private store: Store<fromStore.State>,
    public dialogRef: MatDialogRef<MeteringGroupFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.meteringPointsToAdd = data.selectedMeteringPoints;
    this.addingNewGroup = false;
    this.newGroupName = '';

    this.meteringGroups$ = store.select(fromStore.getMeteringPointGroups);

    this.subs.sink = this.meteringGroups$.pipe(filter(x => !!x)).subscribe(meteringGroups => {
      this.meteringGroupsView = meteringGroups
        .filter(mpg => mpg.meteringType === data.meteringType)
        .map((mpg: MeteringPointGroup) => ({ ...mpg, selected: false }));
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  selectionChange = (event: any) => {
    this.hasNoSelection =
      this.meteringGroupsView.length === 0 || this.meteringGroupsView.filter(x => x.selected).length === 0;
  };

  onCancel(): void {
    this.dialogRef.close('cancel');
  }

  newGroupChange = (event: any) => {
    this.addingNewGroup = event;

    if (this.addingNewGroup) {
      this.groupNameField.nativeElement.focus();
    } else {
      this.newGroupName = '';
      this.groupNameField.nativeElement.blur();
    }
  };

  onSave(): void {
    if (this.addingNewGroup && this.newGroupName.length > 0) { 
      this.addNewGroup();
    }
    const groupsToUpdate = this.meteringGroupsView.filter(meteringGroup => meteringGroup.selected);
    groupsToUpdate.forEach(group => {
      this.meteringPointsToAdd = this.meteringPointsToAdd.filter(
        mp => !group.meteringPoints.some(gmp => gmp.id === mp.id)
      );
      const mps = [...group.meteringPoints, ...this.meteringPointsToAdd];
      group.meteringPoints = mps.map(mp => ({ id: mp.id } as MeteringPoint));
    });

    this.store.dispatch(new fromStore.BulkUpdateMeteringPointGroups(groupsToUpdate));
    this.dialogRef.close('save');
  }

  setFocus() {
    this.addingNewGroup = true;
    this.groupNameField.nativeElement.focus();
  }

  addNewGroup() {
    if (!this.groupNameControlInvalid) {
      const newGroup = {
        id: this.newCounter--,
        name: this.newGroupName,
        meteringPoints: [],
        selected: true,
        meteringType: this.data.meteringType
      } as MeteringPointGroup;

      this.meteringGroupsView = [newGroup, ...this.meteringGroupsView];
    }
  }

  get groupNameControlInvalid() {
    if (this.addingNewGroup) {
      let exist = this.meteringGroupsView.some(
        o => o.name.toLowerCase().trim() === this.newGroupName.trim().toLowerCase()
      );
      return exist;
    }
    return false;
  }
}
